// extracted by mini-css-extract-plugin
export default {"centered":"TableProductsBody_centered__OnAEv","message":"TableProductsBody_message__JrxgI"};